<template>
    <label class="checkbox-block">
        <input type="checkbox"
               :name="name"
               ref="checkbox"
               :checked="value"
               @click="(e) => { onClick(this.name, e.target.checked === true); }"
               @input="$emit('input', $event.target.checked)"
               @change="$emit('change', $event.target.checked)"
        >
    
        <span v-if="labelPosition === 'left'" class="text-sm">{{ label }}</span>
    
        <span class="checkbox" :class="{ 'checked': value === true }">
            <i class="material-icons">check</i>
            <span class="checkbox-material-ring"></span>
        </span>
    
        <span v-if="labelPosition === 'right'" class="text-sm">{{ label }}</span>
    </label>
</template>

<script>
    export default {
        name: "Checkbox",
        props: {
            label: {
                required: true,
                type: String
            },
            value: {
                type: Boolean | String
            },
            name: {
                default: 'input',
                type: String
            },
            onClick: {
                default: () => null,
                type: Function
            },
            labelPosition: {
                type: String,
                default: "right"
            }
        },

        mounted() {
            this.$emit("input", this.$refs.checkbox.checked === true);
        },
    }
</script>

<style scoped>

</style>